import { Route, Routes, useLocation } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import ErrorPage from '../pages/ErrorPage';
import Login from '../pages/Login';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import styles from '../pages/Index.module.scss';
import { Col, Container, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';

interface Props {
  user: User | null;
  loading: boolean;
}

const LoginRoutes: React.FC<Props> = ({ user, loading }) => {
  const [welcomeTitle, setWelcomeTitle] = useState<string>("Bem-vindo(a)!");
  const [welcomeMessage, setWelcomeMessage] = useState<string>("Faça login para acessar o sistema.");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const continueTo = searchParams.get('continue') || '/index';

  useEffect(() => {
    if (continueTo.includes('consultorio')) {
      setWelcomeTitle("Bem-vindo(a) ao seu consultório!");
      setWelcomeMessage("Faça login para acessar o seu consultório.");
    } else if (continueTo.includes('admin')) {
      setWelcomeTitle("Bem-vindo(a) ao painel de administração!");
      setWelcomeMessage("Faça login para acessar o painel de administração.");
    }
  }, [continueTo]);

  const isAuthenticated = !!user;
  if (isAuthenticated) {
    return <Navigate to={continueTo} />;
  }


  return (
    <Container className={styles["container"]}>
      <Row className={[styles["data-content"], "align-items-center"].join(' ')} id="contato">
        <Col md="6" className={[styles["text-content"], styles["center"]].join(" ")}>
          <h2>{welcomeTitle}</h2>
          <p>{welcomeMessage}</p>
        </Col>
        <Col md="6" className={styles["text-content"]}>
          <Routes>
            <Route path="/" element={<Login loading={loading} />} />
            <Route path="/esqueci-senha" element={<ForgotPassword loading={loading} />} />
            <Route path="/recuperar-senha" element={<ResetPassword loading={loading} />} />

            {/* Rota fallback para páginas não encontradas */}
            <Route path="*" element={<ErrorPage code={404} />} />
          </Routes>
        </Col>
      </Row>
    </Container >
  );
};

export default LoginRoutes;
